import state from './moduleEmailLogState.js'
import mutations from './moduleEmailLogMutation.js'
import actions from './moduleEmailLogActions.js'
import getters from './moduleEmailLogGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
